export default "__VITE_ASSET__BoshPmvp__"